import styled from 'styled-components';

import { FlexRow, Span } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

export const PromoSmsConsentCheckboxContainer = styled(FlexRow)`
  margin: 0 0 10px;
  gap: 10px;
`;

export const PromoSmsConsentCheckboxLabel = styled(Span)`
  display: inline-block;
  color: ${colors.charcoal};
  cursor: pointer;
`;
